import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {
  pageName;
  public language: string = '';
  isEnglishPageTranslation = false;
  servicesArray = [];
  servicesArrayEn = [
    {
      name: 'invoice',
      title: 'Invoice',
      p: "EasyKash INVOICE is the market's fastest and safest digital payment solution, allowing you to be paid for your work easily. It's secure, simple to use.",
      content6: 'Create your own invoice in seconds.',
      whenToUse:
        'Invoice is commonly used for one-time purchases, customized payments, ongoing payments or subscriptions, and any remote services.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/invoice.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/Invoice mock.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/invoice.png',
    },
    {
      name: 'subscription',
      title: 'Subscription',
      p: 'EasyKash SUBSCRIPTIONS assists businesses in gaining control of what they earn while effectively managing the time of the money they receive.',
      content6:
        'Customize your payment page to add packages with price, and duration.',
      whenToUse:
        'When the business has monthly subscriptions so he can add each package with its details and the client can pay the package through it with all payments option.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/subscription.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/Subscription mock.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/sub.png',
    },
    {
      name: 'customPayment',
      title: 'Custom Payment',
      p: 'With EasyKash CUSTOM PAYMENTS, clients may spend less time waiting for items and more time enjoying their purchases. Custom payment is a QR code payment solution that simplifies checkouts.',
      content6:
        'Customize a QR Code or link to allow customers to pay with one click.',
      whenToUse:
        ' Businesses can utilize QR codes to scan at bazaars, shopping malls, and online.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/custom payment.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/scan.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/custom-payment.png',
    },
    {
      name: 'product',
      title: 'Product',
      p: "EasyKash PRODUCT is the most efficient and easy method to market your items online. You don't need a website. in seconds, you can build and distribute links to a product page including a single or several products to your customers.",
      content6:
        'Customize product images and orders, and allow customers to pay in advance.',
      whenToUse:
        'Physical products are frequently used by online businesses that sell on Facebook and Instagram but do not have websites.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/product.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/product mock.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/product.png',
    },
    {
      name: 'quickCash',
      title: 'Quick Cash',
      p: ' EasyKash QUICK CASH helps sellers share a quick cash invoice with their customers to pay easily through any Aman kiosk.',
      content6:
        'Create your own quick cash invoice and let customers pay easily.',
      whenToUse:
        'If you wish to collect cash from your clients without requiring them to use the Easykash website.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/quick cash.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/quick-cash.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/quk-cash.png',
    },
    {
      name: 'quickPayment',
      title: 'Quick Payment',
      p: 'EasyKash QUICK PAYMENT helps businesses generate a payment link in seconds and send it to their customers to pay with a credit card.',
      content6:
        'Customize and share a credit card payment link with customers.',
      whenToUse:
        'If you want to quickly receive a specified amount from a customer without establishing a product with full details.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/quick payment.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/quick-payment.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/quk-payment.png',
    },
    {
      name: 'e-Reservation',
      title: 'E-Reservation',
      p: ' EasyKash E-Reservation is a flexible online reservation service for any business which needs scheduling and managing their bookings.',
      content6: 'Create an event and make it easy for customers to reserve it.',
      whenToUse:
        'E-Reservation is often used for Events, Training Centres, Trips & Travel, Concerts, and Festivals, among other businesses.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/e-reservation.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/E-reservation mock.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/e-resr.png',
    },
    {
      name: 'installmentOptions',
      title: 'Installment Options',
      p: 'EasyKash installment Options are payment options that allow your customers to purchase anything today in affordable monthly payments.',
      content6:
        '9 installment options to let your customer choose between them.',
      whenToUse:
        ' Installment options are used When a consumer needs to split the expense of a product or service.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/installation options.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/install.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/lap-installment.png',
    },
    {
      name: 'booking&Events',
      title: 'Booking & Events',
      p: 'EasyKash BOOKING & EVENTS service Allows users to select and schedule individual time slots during your events. Provide the exact dates and times you want to schedule and let users make appointments directly from your online calendar.',
      content6: ' Create an events calendar to easily book events.',
      whenToUse:
        'Booking and events are used by businesses who need to create their own events calendar so that clients can easily learn about and book their upcoming events.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/booking and events.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/booking.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/booking-events.png',
    },
  ];
  servicesArrayAr = [
    {
      name: 'invoice',
      title: 'الفاتوره',
      p: 'فاتورة ايزي كاش هي حل الدفع الإلكتروني الأسرع والأكثر أمانًا في السوق ، مما يسمح لك بالدفع مقابل عملك بسهولة وآمان.',
      content6: 'قم بإنشاء الفاتورة الخاصة بك في ثواني.',
      whenToUse: 'تستخدم الفاتوره لعمليات الشراء لمرة واحدة , الاشتراكات الشهريه / السنويه , المدفوعات المتكررة والمحدده , و لكل الخدمات عن بعد.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/invoice.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/Invoice mock.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/invoice.png',
    },
    {
      name: 'subscription',
      title: 'الاشتراكات',
      p: 'تساعد اشتراكات ايزي كاش الشركات على التحكم في ما تكسبه مع إدارة الوقت والأموال التي تتلقاها بشكل فعال.',
      content6: 'قم بتخصيص صفحة الدفع الخاصة بك لإضافة أسعارك والمدة.',
      whenToUse:
        'عندما يكون البيزنس الخاص بك لديه اشتراكات شهرية تستطيع إضافة كل خدماتك بكل تفاصيلها و يستطيع عملائك الاشتراك في خدماتك و تتم عملية الدفع في نفس الصفحه و في نفس الوقت',
      background:
        '../../../../../assets/images/servicesPages/services-bg/subscription.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/Subscription mock.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/sub.png',
    },
    {
      name: 'customPayment',
      title: 'الدفع المخصص',
      p: 'مع مدفوعات ايزي كاش المخصصة، يقضي العملاء وقتًا أقل في انتظار المنتجات والمزيد من الوقت للاستمتاع بمشترياتهم. الدفع المخصص هو حل دفع إلكتروني باستخدام رمز الـ QR الذي يُسهل عمليات الدفع.',
      content6:
        ' قم بتخصيص رمز الـ QR أو رابط خاص بك للسماح لعملائك بالدفع بضغطة زِر.',
      whenToUse: 'عندما يكون لديك بازارات او مراكز او حتى اونلاين.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/custom payment.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/scan.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/custom-payment.png',
    },
    {
      name: 'product',
      title: 'المنتج المادي',
      p: ' منتجات ايزي كاش المادية هي الطريقة الأكثر فعالية وسهولة لتسويق منتجاتك عبر الإنترنت. لن تحتاج إلى ويب سايت. يمكنك إنشاء لينك لصفحة المنتج وتوزيعه بما في ذلك منتج واحد أو عدة منتجات لعملائك في ثواني.',
      content6: 'خصص صور المنتج والطلبات ، و اسمح لعملائك بالدفع مقدمًا.',
      whenToUse:
        ' إذا كان لديك مشروع اونلاين تبيع به منتجات من خلال الفيس بوك او الانستجرام و ليس لديك ويب سايت، فستقوم هذه الخدمة بمساعدتك على البيع والربح أكثر.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/product.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/product mock.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/product.png',
    },
    {
      name: 'quickCash',
      title: 'الكاش السريع',
      p: 'تساعد خدمة الكاش السريع من ايزي كاش البائعين على مشاركة فاتورة نقدية سريعة مع عملائهم للدفع بسهولة من خلال أي كشك أمان.',
      content6:
        ' قم بإنشاء الفاتورة النقدية الخاصة بك و اجعل عميلك يقوم بالدفع بسهولة.',
      whenToUse:
        ' في حالة انك تريد الحصول على مالك من عملائك بدون الطلب منهم بإستخدام موقع ايزي كاش.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/quick cash.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/quick-cash.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/quk-cash.png',
    },
    {
      name: 'quickPayment',
      title: 'الدفع السريع',
      p: 'تساعد خدمة الدفع السريع من ايزي كاش الشركات على إنشاء لينك دفع في ثواني وإرساله إلى عملائهم للدفع ببطاقة الائتمان.',
      content6: 'خصص وشارك لينك الدفع ببطاقة الائتمان مع العملاء.',
      whenToUse:
        'في حالة انك تريد استلام مبلغ محدد من عملائك في وقت أسرع بدون إضافة منتجاتك و التفاصيل الخاصة بها, الدفع السريع سيكون أفضل حل لك.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/quick payment.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/quick-payment.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/quk-payment.png',
    },
    {
      name: 'e-Reservation',
      title: 'الحجز الإلكتروني',
      p: 'خدمة الحجز الإلكتروني من ايزي كاش هي عملية حجز سريعة عبر الإنترنت لأي شركة تحتاج إلى جدولة وإدارة حجوزاتها.',
      content6: ' أنشئ فعالية وسهّل على عملائك حجزها.',
      whenToUse:
        'تستطيع استخدامه في الحفلات , المهرجانات , الاحداث الهامه , مراكز التدريب , الرحالات , السفر و اي بيزنس اخر.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/e-reservation.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/E-reservation mock.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/e-resr.png',
    },
    {
      name: 'installmentOptions',
      title: 'خيارات التقسيط',
      p: 'خيارات التقسيط من ايزي كاش هي طرق دفع تتيح لعملائك شراء أي شيء بدُفعات شهرية قليلة التكلفة.',
      content6: '9 خيارات تقسيط للسماح لعميلك بالاختيار من بينها.',
      whenToUse: ' إذا عميلك يحتاج إلى تقسيم تكلفة المنتج أو الخدمة الخاصة بك على فترات.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/installation options.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/install.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/laptop-installment-Ar.png',
    },
    {
      name: 'booking&Events',
      title: 'الفعاليات والحجز',
      p: 'خدمة الفعاليات والحجز من ايزي كاش تتيح للمستخدمين تحديد وجدولة فترات زمنية فردية أثناء الأحداث الخاصة بك. قم بتوفير التواريخ والأوقات التي تريد جدولتها والسماح لعملائك بتحديد المواعيد التي يريدون حجزها من تقويمك عبر الإنترنت.',
      content6: 'قم بإنشاء تقويم الفعاليات القادمة لحجزها بسهولة.',
      whenToUse:
        'يتم استخدامها إذا كنت تحتاج إلى إنشاء تقويم الفعاليات الخاص بك بحيث يمكن لعملائك التعرف بسهولة على فعالياتك القادمة وحجزها.',
      background:
        '../../../../../assets/images/servicesPages/services-bg/booking and events.png',
      mobilemockup:
        '../../../../../assets/images/servicesPages/Mobile services page/booking.png',
      labtopmockup:
        '../../../../../assets/images/servicesPages/Services Laptop/booking-events.png',
    },
  ];
  options: OwlOptions;
  installmentPartnersArray = [
    { image: '../../../../../assets/images/payment-options/aman.webp' },
    { image: '../../../../../assets/images/payment-options/bank ahly.webp' },
    { image: '../../../../../assets/images/payment-options/bank misr.webp' },
    { image: '../../../../../assets/images/payment-options/Bank qahera.webp' },
    { image: '../../../../../assets/images/payment-options/CIB.webp' },
    { image: '../../../../../assets/images/payment-options/contact.webp' },
    { image: '../../../../../assets/images/payment-options/emirates.webp' },
    { image: '../../../../../assets/images/payment-options/mashreq.webp' },
    { image: '../../../../../assets/images/payment-options/nbk.webp' },
    { image: '../../../../../assets/images/payment-options/souhoola.webp' },
    { image: '../../../../../assets/images/payment-options/valu.webp' },
  ];

  constructor(
    private activateroute: ActivatedRoute,
    private translate: TranslateService
  ) {
    this.options = {
      loop: true,
      mouseDrag: true,
      touchDrag: true,
      autoplay: true,
      autoplayTimeout: 5000,
      autoplaySpeed: 500,
      items: 1,
      dots: true,
      autoWidth: true,
      nav: false,
      responsiveRefreshRate: 500,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        1000: {
          items: 5,
        },
      },
    };
  }

  ngOnInit(): void {
    this.language =localStorage.getItem('language');
    this.servicesArray = this.language == "en"? this.servicesArrayEn :this.servicesArrayAr
    this.translate.onLangChange.subscribe((res) => {
      let lang = res.lang;
      this.options =
      lang === 'en' ? this.options : { ...this.options, rtl: true };
      if (lang === 'ar') {
        this.language = 'ar';
        this.servicesArray = [...this.servicesArrayAr];
      } else if (lang === 'en') {
        this.language = 'en';
        this.servicesArray = [...this.servicesArrayEn];
      }
    });

    this.activateroute.params.subscribe((params) => {
      this.pageName = params['service'];
    });
  }

  getContentByServiceName(name: string) {
    return this.servicesArray.find((content) => content.name === name);
  }
}
